import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';
import ChatToast from './ChatToast';
import StudentChatPanel from './StudentChatPanel';
import { useStudentChat } from './StudentChatContext';
import './StudentChat.css';

export default function StudentChat() {
  const chat = useStudentChat();
  const [panelOpen, setPanelOpen] = useState(false);

  if (!chat?.onSend) return null;

  const { messages, unreadCount, historyCount, onSend, onRead, toast, onDismissToast } = chat;

  const handleOpen = () => {
    setPanelOpen(true);
    onRead?.();
    onDismissToast?.();
  };

  return (
    <>
      <button className="student-chat-fab" onClick={handleOpen} aria-label="Open chat">
        <MessageCircle size={22} />
        {(unreadCount ?? 0) > 0 && (
          <span className="student-chat-fab__badge">
            {(unreadCount ?? 0) > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      {panelOpen && (
        <StudentChatPanel
          messages={messages ?? []}
          onSend={onSend}
          onClose={() => setPanelOpen(false)}
          historyCount={historyCount ?? 0}
          onRead={onRead}
        />
      )}

      {!panelOpen && (
        <ChatToast
          toast={toast}
          onDismiss={onDismissToast}
          onClick={handleOpen}
        />
      )}
    </>
  );
}
